import {
  TransactionItem,
  TransactionPayment,
} from '../__generated__/graphql.generated';

import { formatCurrency } from './currency';

export const formatInvoiceNumber = (number: number) => {
  return `#${1000 + number}`;
};

export const formatInvoiceStatus = (status: string) => {
  if (status === 'ready' || status === 'paid' || status === 'completed') {
    return 'Paid';
  }
  return 'Unknown';
};

export const formatPaymentMethod = (payment: TransactionPayment) => {
  if (payment.method === 'card' && payment.card) {
    return `${payment.card.type?.toLocaleUpperCase()} ****${payment.card.last4}`;
  }
  if (payment.method === 'apple_pay') {
    return `Apple Pay`;
  }
  if (payment.method === 'paypal') {
    return `PayPal`;
  }
  return payment.method.toLocaleUpperCase();
};

export const formatItem = (item: TransactionItem) => {
  return `${item.name} - ${formatCurrency(item.price)}`;
};
